












import { Vue, Component } from 'vue-property-decorator'
import AppBar from '@/components/AppBar.vue'
import Footer from '@/components/Footer.vue'

@Component({ components: { AppBar, Footer } })
export default class App extends Vue {}
